export enum StepPosition {
    BEFORE = "BEFORE",
    AFTER = "AFTER"
  }